import { useEffect, useState } from "react";
import type { FallbackIconConfig, ImageWithFallbackProps } from "./types";
import { cn } from "@/lib/utils";
import Icon from "../Icon";
import AsyncImage from "../AsyncImage/AsyncImage";

const FALLBACK_ICON: FallbackIconConfig = {
  user: "user",
  project: "file-text",
  ecosystem: "globe",
  token: "token",
} as const;

const ImageWithFallback = ({ src, alt = "", className = "", type, ...props }: ImageWithFallbackProps) => {
  const [error, setError] = useState(!src);

  const handleError = () => {
    setError(true);
  };

  useEffect(() => {
    setError(!src);
  }, [src]);

  if (error || !src) {
    return (
      <div className={cn(className, "flex items-center justify-center border border-white/40 bg-[transparent]")}>
        <Icon name={FALLBACK_ICON[type]} className="h-[60%] w-[60%]" />
      </div>
    );
  }
  return (
    <AsyncImage
      src={src!}
      alt={alt}
      className={className}
      onError={handleError}
      {...props}
      wrapperClassName="shrink-0"
    />
  );
};

export default ImageWithFallback;
